<template>
  <div class="active">
    <base-card
      :listTitle="this.listTitle"
      :listContent="this.listContent"
      :listUrl="this.listUrl"
    ></base-card>
    <base-box :key="this.reRenderKey" :article="this.article"></base-box>
  </div>
</template>

<script>
import BaseCard from "../components/BaseCard.vue";
import BaseBox from "../components/BaseBox.vue";
import getPath from "../utils/getPath";
import getArticleList from "../utils/getArticleList";

export default {
  components: {
    BaseCard,
    BaseBox
  },
  data() {
    return {
      article: {},
      listTitle: "",
      listContent: {},
      listUrl: "",
      isRender: false,
      reRenderKey: 0
    };
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        getPath(this.$http, newVal, "/dingyang/show-edit-article/").then(
          res => {
            if (res.data.data) {
              this.article.title = res.data.data[0].title;
              this.article.content = res.data.data[0].content;
              this.forceRerender();
            }
          }
        );
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    getArticleList(this.$http, "/dingyang/get-articles", "", "", "2", "8").then(
      articleList => {
        this.listContent = articleList.data.data;
        this.listTitle = "关于我们";
        this.listUrl = "/#/active/";
      }
    );
  },
  methods: {
    forceRerender() {
      this.reRenderKey += 1;
    }
  }
};
</script>

<style scoped>
.active {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue